export const CHOOSE_OPTION_LABEL = 'Choose…';
export const EMPTY_VALUE_LABEL = 'Not provided';
export const NOT_APPLICABLE_LABEL = 'Not applicable';

export function getFormFieldPlaceholder(field = {}) {
  const configuredPlaceholder = typeof field.placeholder === 'string'
    ? field.placeholder.trim()
    : '';
  if (configuredPlaceholder) return configuredPlaceholder;

  if (field.type === 'number') return 'Enter a number…';
  if (field.type === 'textarea' || field.type === 'long_text') return 'Add details…';
  if (!field.type || field.type === 'text' || field.type === 'short_text') return 'Enter a response…';
  return undefined;
}
